import React from 'react'
import {
  Inject,
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  PieSeries,
  AccumulationDataLabel,
  AccumulationSeriesDirective,
  AccumulationLegend,
  AccumulationTooltip,
  LegendSettingsModel,
} from '@syncfusion/ej2-react-charts'
import '../DashboardStyle.css'
import { PieChartProps } from '@dataTypes/pieChart.type'

const PieChart = ({
  title,
  center,
  data,
  legendSettings,
  legendShape,
  radius,
  height,
  width,
  tooltipEnabled,
  innerRadius,
  legendTitle,
}: PieChartProps): React.ReactElement => {
  const defaultLegendSettings: LegendSettingsModel = {
    visible: true,
    position: 'Top',
    alignment: 'Center',
    title: legendTitle ?? '',
  }

  return (
    <div className="dashboard-control-pane" key={title}>
      <div className="dashboard-control-section">
        <AccumulationChartComponent
          id={title}
          center={center ?? undefined}
          enableSmartLabels={true}
          enableBorderOnMouseMove={false}
          legendSettings={legendSettings ?? defaultLegendSettings}
          tooltip={{
            enable: tooltipEnabled ?? true,
          }}
          height={height ?? '300'}
          width={width ?? '600'}
        >
          <Inject
            services={[
              AccumulationLegend,
              PieSeries,
              AccumulationDataLabel,
              AccumulationTooltip,
            ]}
          />
          <AccumulationSeriesCollectionDirective>
            <AccumulationSeriesDirective
              dataSource={data}
              xName="name"
              yName="y"
              name="name"
              pointColorMapping="color"
              radius={radius ?? undefined}
              innerRadius={innerRadius ?? '50%'}
              legendShape={legendShape ?? 'Rectangle'}
            />
          </AccumulationSeriesCollectionDirective>
        </AccumulationChartComponent>
      </div>
    </div>
  )
}

export default PieChart
